import { useState } from 'react';
import get from 'lodash.get';
import Box from '../Box';
import InfoPanel from './InfoPanel';
import EditForm from './EditForm';
import Enums from 'utilities/enumHelper';
import fmsEnums from 'constants/componentData/fmsEnums';

const PRIMARY = fmsEnums.typeofContact.primary;
const SECONDARY = fmsEnums.typeofContact.secondary;
const EMERGENCY = fmsEnums.typeofContact.emergency;

const EmergencyContact = props => {
  const [edit, setEdit] = useState(false);
  const { profile, mappings, update } = props;
  const { basicInfo: info } = profile || {};
  const type = typeOf => item => item.typeofContact === typeOf;
  const contacts = get(profile, 'alternativeContacts', []) || [];
  const contact = contacts.find(i => i.typeofContact === EMERGENCY) || {};
  const getContact = (path, value = '') => get(contact, path, value) || value;

  const name = getContact('basicInfo.name', '');
  const phoneNumbers = getContact('phoneNumbers', []);
  const phone = phoneNumbers.find(type(PRIMARY)) || {};
  const mobile = phoneNumbers.find(type(SECONDARY)) || {};
  const addresses = getContact('addresses', []);
  const address = addresses.find(type(PRIMARY)) || {};

  const relationship = Enums.valueToOptionLabel(
    mappings.relationship,
    getContact('relationship'),
  );

  const onEdit = () => setEdit(true);

  return (
    <Box title="Emergency Contact" onEdit={!edit && onEdit}>
      {edit ? (
        <EditForm
          name={name}
          address={address}
          phone={phone}
          mobile={mobile}
          contact={contact}
          mappings={mappings}
          dbCode={info.dbCode}
          idType={info.idType}
          onCancel={() => setEdit(false)}
          onSave={update}
        />
      ) : (
        <InfoPanel
          name={name}
          address={address}
          phone={phone}
          mobile={mobile}
          relationship={relationship}
        />
      )}
    </Box>
  );
};

export default EmergencyContact;
